var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],style:({
    gridColumnGap: `${_vm.gridColumnGap}px`,
    gridRowGap: `${_vm.gridRowGap}px`,
    gridTemplateColumns: `repeat(${_vm.cols}, 1fr)`,
  }),attrs:{"id":"grid"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }